<div class="file-management">
  <h1 class="file-management__title">Управління файлами</h1>

  <mat-card class="file-management__card">
    <mat-card-header>
      <mat-card-title>Портал</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="file-management__inputs">
        <mat-form-field appearance="outline" class="file-management__portal">
          <mat-label>Портал</mat-label>
          <mat-select [formControl]="portalControl">
            @for (portal of portals$ | async; track portal.id) {
              <mat-option [value]="portal.id">{{ portal.name }} (#{{ portal.id }})</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button mat-stroked-button color="primary" (click)="refreshStatistics()" [disabled]="!portalControl.value">
          Оновити статистику
        </button>
      </div>

      @if (statistic$ | async; as statistic) {
        <div class="file-management__statistic">
          <div class="file-management__statistic-item">
            <span class="file-management__statistic-label">Для класифікації (NEW + NORMALIZED):</span>
            <strong>{{ classifyCount$ | async }}</strong>
          </div>
          <div class="file-management__statistic-item">
            <span class="file-management__statistic-label">Для векторизації (PARSED):</span>
            <strong>{{ vectorizeCount$ | async }}</strong>
          </div>
        </div>
      } @else if (statisticLoading$ | async) {
        <p class="file-management__hint">Завантаження статистики...</p>
      } @else if (portalControl.value) {
        <p class="file-management__hint">Статистика не завантажена.</p>
      } @else {
        <p class="file-management__hint">Оберіть портал, щоб побачити статистику.</p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="file-management__card">
    <mat-card-header>
      <mat-card-title>Параметри</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="file-management__inputs">
        <mat-form-field appearance="outline">
          <mat-label>Ліміт</mat-label>
          <input matInput type="number" [formControl]="limit" placeholder="100" />
        </mat-form-field>

        <mat-checkbox [formControl]="forceProcessing">Примусова обробка</mat-checkbox>
      </div>

      <div class="file-management__inputs">
        <mat-form-field appearance="outline">
          <mat-label>Batch ID</mat-label>
          <input matInput [formControl]="batchId" placeholder="Введіть Batch ID" />
        </mat-form-field>

        <mat-radio-group [formControl]="provider" class="file-management__provider">
          <mat-radio-button value="openai">OpenAI</mat-radio-button>
          <mat-radio-button value="anthropic">Anthropic</mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="file-management__card">
    <mat-card-header>
      <mat-card-title>Дії</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="file-management__buttons">
        <button mat-raised-button color="accent" (click)="classifyFiles()" [disabled]="!portalControl.value">
          Класифікувати файли
        </button>
        <button mat-raised-button color="primary" (click)="vectorizeTextContent()" [disabled]="!portalControl.value">
          Векторизувати текстовий контент
        </button>
        <button
          mat-raised-button
          color="accent"
          [disabled]="!portalControl.value"
          (click)="processOrphanTextContent('missed_sections')"
        >
          Обробити orphan контент (відсутні секції)
        </button>
        <button
          mat-raised-button
          color="accent"
          [disabled]="!portalControl.value"
          (click)="processOrphanTextContent('missed_embeddings')"
        >
          Обробити orphan контент (відсутні embeddings)
        </button>
        <button mat-raised-button color="accent" (click)="processExistedBatch()">Обробити існуючий батч</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
